import styled from"@emotion/styled";import{Form}from"@wp/src/components/common/form";import{FlexLayout,getColumnSpacingStyles,getRowSpacingStyles,mediaQuery}from"@wp/src/components/common/grid";import{StyledFormItem}from"@wp/src/components/screenComponents/portfolio/investmentsManager/investmentUpsertForm/atoms";import Button from"@wp/src/components/common/button";import{AntdSelect}from"@wp/src/components/common";export const StyledForm=styled(Form)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;

  ${getRowSpacingStyles(16)}
`;export const SeriesNameFormItem=styled(StyledFormItem)`
  .ant-form-item-control-input-content {
    height: 40px;
  }
`;export const TickerFormItem=styled(StyledFormItem)`
  ${mediaQuery({minWidth:["128px"]})}
`;export const AmountFormItem=styled(StyledFormItem)``;export const InvestmentBasicDetailsContainer=styled.div`
  width: 100%;
  display: grid;
  row-gap: 16px;
  grid-template-columns: 3fr 1fr;

  > :first-of-type {
    margin-right: 16px;
  }

  > :nth-child(3) {
    ${mediaQuery({width:["100%","48%"],gridColumn:["1 / 4","1 / 3"]})}
  }
`;export const ProxyTickerFormItem=styled(StyledFormItem)`
  width: 100%;

  .ant-form-item-control-input-content {
    height: 40px;
  }
`;export const SecurityStatsFieldsContainer=styled.div`
  width: 100%;
  display: grid;

  ${mediaQuery({gap:["16px","24px"]})}

  ${props=>props.fullWidthItems?mediaQuery({gridTemplateColumns:["1fr"]}):mediaQuery({gridTemplateColumns:["1fr","1fr 1fr"]})}
`;export const SecurityProxyNoticeContainer=styled(FlexLayout)`
  padding: 8px 16px;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  ${getRowSpacingStyles(16)};
  ${getColumnSpacingStyles(16)};

  border-radius: var(--card-border-radius, 8px);
  background: ${props=>props.theme.colors.neutral100};
`;export const SecurityManagementFormSelect=styled(AntdSelect)`
  width: 100%;
  min-width: 160px;
`;export const ResetSecurityButton=styled(Button)`
  margin-top: 24px;

  ${mediaQuery({width:["100%","48%"]})}
`;